import WorkoutButton from './WorkoutButton';

export default WorkoutButton;
